import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from '@/components/layout/Container';
import { CONTACT_SALES_EMAIL, CONTACT_SALES_EMAIL_HREF } from '@/lib/contact';
import styles from './Footer.module.css';

export const Footer: FC = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className={styles.root}>
      <Container size="wide">
        <div className={styles.inner}>
          <span className={styles.brand}>{t('common.brand')}</span>
          <a className={styles.contact} href={CONTACT_SALES_EMAIL_HREF}>
            {CONTACT_SALES_EMAIL}
          </a>
          <span className={styles.meta}>
            © {year} {t('common.brand')}. {t('common.footer.rights')}
          </span>
        </div>
      </Container>
    </footer>
  );
};

Footer.displayName = 'Footer';
